import { MicroMoments } from '../models/micro-moments.interfaces';

export const RolloverMedallionQualificationMilesMocks: MicroMoments = {
  id: '',
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/rollover-medallion-qualifying-miles.svg',
    alt: 'Roll Over MQDs'
  },
  title: 'You’ve got Rollover MQMs that you can apply.',
  action: {
    label: 'Apply Rollover',
    url: '/myskymiles/convertmqms'
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
